/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfBoolean
 */
export interface ResultOfBoolean {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfBoolean
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBoolean
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBoolean
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBoolean
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBoolean
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfBoolean
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfBoolean
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfBoolean
     */
    data: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBoolean
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfBoolean interface.
 */
export function instanceOfResultOfBoolean(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfBooleanFromJSON(json: any): ResultOfBoolean {
    return ResultOfBooleanFromJSONTyped(json, false);
}

export function ResultOfBooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfBoolean {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': json['Data'],
        'count': json['Count'],
    };
}

export function ResultOfBooleanToJSON(value?: ResultOfBoolean | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data,
        'Count': value.count,
    };
}

